import React from 'react';
import "./FAQ.css";
import { Col, Container, Row } from 'react-bootstrap';

function FAQ() {
return (
    <section className="pb-lg-5 pt-4 margin-left">
    <Container fluid>
        <Row>
        <Col>
        <div className="dash-heading">
            <h5 className="fw-bold text-black">FAQ</h5>
            <p>??</p>
            </div>
        </Col>
        </Row>
    </Container>
    </section>
);
}

export default FAQ;